import React from 'react';
import { ArrowTrendingUpIcon, ArrowTrendingDownIcon, MinusIcon } from '@heroicons/react/24/solid';

interface RiskTrendIconProps {
  trend?: 'increasing' | 'decreasing' | 'stable';
  delta?: number;
  showDelta?: boolean;
  className?: string;
}

const RiskTrendIcon: React.FC<RiskTrendIconProps> = ({ trend, delta, showDelta = true, className = "" }) => {
  if (!trend || trend === 'stable') {
    return (
      <div className={`flex items-center gap-1 text-slate-400 ${className}`}>
        <MinusIcon className="w-3 h-3" />
        {showDelta && <span className="text-[10px] font-bold">STABLE</span>}
      </div>
    );
  }

  if (trend === 'increasing') {
    return (
      <div className={`flex items-center gap-1 text-red-600 ${className}`}>
        <ArrowTrendingUpIcon className="w-3 h-3" />
        {showDelta && delta !== undefined && (
          <span className="text-[10px] font-black">+{delta.toFixed(1)}</span>
        )}
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-1 text-emerald-600 ${className}`}>
      <ArrowTrendingDownIcon className="w-3 h-3" />
      {showDelta && delta !== undefined && (
        <span className="text-[10px] font-black">{delta.toFixed(1)}</span>
      )}
    </div>
  );
};

export default RiskTrendIcon;
